import { render, staticRenderFns } from "./ColdClients.vue?vue&type=template&id=8ee27db4&"
import script from "./ColdClients.vue?vue&type=script&lang=js&"
export * from "./ColdClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports